const beforeNextTick = Promise.resolve().then.bind(Promise.resolve());
export default beforeNextTick;
